import { useCallback, useRef, useState } from "react";

export function useSlideOverSubmit() {
  const [submitting, setSubmitting] = useState(false);
  const submittingRef = useRef(false);

  const runSubmit = useCallback(async (asyncFn) => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setSubmitting(true);
    try {
      await asyncFn();
    } finally {
      submittingRef.current = false;
      setSubmitting(false);
    }
  }, []);

  return { submitting, runSubmit };
}
